import { Col, Paper } from "@commonlibs";
import styled, { css } from "styled-components";

export const AccountCardRoot = styled(Paper)(
    () => css`
        border-radius: 0px 0px 30px 30px;
        padding: 25px 20px 20px 20px;
        display: grid;
        grid-template-columns: 50px 1fr 55px;
        width: 100%;
        height: 135px;
        background: transparent;
    `,
);

export const QRColRoot = styled(Col)(
    () => css`
        margin-top: 5px;
        justify-content: start;
    `,
);

export const QrButton = styled.button(
    () => css`
        background: transparent;
        border: none;
        padding: 0px;
        cursor: pointer;
        img {
            width: 100%;
        }
    `,
);

export const WalletColRoot = styled(Col)(
    () => css`
        margin-top: 5px;
        justify-content: start;
        img {
            width: 35px;
        }
    `,
);
